import { gql, TypedDocumentNode } from '@common/hooks';
import { FullValidationErrorFragment } from '@common/graphql/fragments';
import {
  CreateUnitShiftGapTagMutationCgResponse,
  CreateUnitShiftGapTagMutationVariables,
  EditUnitShiftGapTagMutationCgResponse,
  EditUnitShiftGapTagMutationVariables,
  ArchiveUnitShiftGapTagMutationCgResponse,
  ArchiveUnitShiftGapTagMutationVariables,
} from '@common/graphql/schema';

export const CREATE_UNIT_SHIFT_GAP_TAG_MUTATION: TypedDocumentNode<
  CreateUnitShiftGapTagMutationCgResponse,
  CreateUnitShiftGapTagMutationVariables
> = gql`
  mutation CreateUnitShiftGapTag($input: CreateShiftGapTagInput!) {
    createShiftGapTag(input: $input) {
      shiftGapTag {
        id
        name
        description
        scope
        organizationUnit {
          id
          name
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;

export const EDIT_UNIT_SHIFT_GAP_TAG_MUTATION: TypedDocumentNode<
  EditUnitShiftGapTagMutationCgResponse,
  EditUnitShiftGapTagMutationVariables
> = gql`
  mutation EditUnitShiftGapTag($id: ID!, $input: EditShiftGapTagInput!) {
    editShiftGapTag(id: $id, input: $input) {
      shiftGapTag {
        id
        name
        description
        scope
        organizationUnit {
          id
          name
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;

export const ARCHIVE_UNIT_SHIFT_GAP_TAG_MUTATION: TypedDocumentNode<
  ArchiveUnitShiftGapTagMutationCgResponse,
  ArchiveUnitShiftGapTagMutationVariables
> = gql`
  mutation ArchiveUnitShiftGapTag($input: ArchiveShiftGapTagInput!) {
    archiveShiftGapTag(input: $input) {
      shiftGapTag {
        id
        name
        description
        scope
        organizationUnit {
          id
          name
        }
      }
      errors {
        ...FullValidationErrorFragment
      }
    }
  }
  ${FullValidationErrorFragment}
`;
